export default __webpack_public_path__ + "static/media/6.49f9776a.svg";